let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("grbhN")).then(() => parcelRequire('5cloc'));